import _ from 'underscore';
import $ from 'jquery';
import React from 'react';
import ReactDom from 'react-dom';
import { getPrimaryContacts, postPrimaryContactUpdate } from '@bingads-webui-campaign-legacy/primary-contact/index';
import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';
import { EditPrimaryContact } from '@bingads-webui-cc-react/edit-primary-contact';

const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!@bingads-webui-cc-react/edit-primary-contact');

// This plugin responds to the event of clicking "bulk edit primary contacts" in Management Grid
// The plugin will first make a ajax call to CCUI to see if selected accounts are eligible to make the change
// and get the primary contact list for submitting.
export default defineGridPlugin(
  'primaryContactBulkEditor',
  ['gridView'], (gridView, pulginConfig ) => {

    const containerId = 'BulkEditContainer';
    let editorContainer;
    let toolbar;
    let isEditing = false;

    if (pulginConfig && pulginConfig.existingContainer && $(pulginConfig.existingContainer).length) {
      editorContainer = $(pulginConfig.existingContainer);
    } else {
      editorContainer = $(`<div id='${containerId}'></div>`);
      editorContainer.hide();
      $('.bingadsgrid').prepend(editorContainer);
    }
    editorContainer.empty();

    function showToolbar() {
      toolbar.show();
      // In Management tab the grid itself has fixed height so hide it here.
      // TODO: Bug#1895168 to see if we have better way to hide the toolbar.
      $('.grid-toolbar').show();
    }

    function hideToolbar() {
      // In Management tab the grid itself has fixed height so hide/show it here.
      // TODO: Bug#1895168 to see if we have better way to hide the toolbar.
      $('.grid-toolbar').hide();
      toolbar.hide();
    }

    function hide() {
      editorContainer.slideUp('normal', () => ReactDom.unmountComponentAtNode(editorContainer[0]));
      showToolbar();
      isEditing = false;
    }

    const afterUpdate = ({result, callBack}) => {
      if (result.IsSuccess) {
        window.App.views.alertCenter.showConfirmation(result.Message);
        hide();
        callBack();
      }
    };

    const renderPrimaryContactReactComponent = (props) => {
      ReactDom.render(
        React.createElement(EditPrimaryContact, props, null),
        editorContainer[0]
      );
    };

    const renderEditComponent = ({cid, uid, callBack, data}) => {
      let props = {
        contacts: data.contacts,
        selected: data.selectedUser || {},
        warning: data.warningMessage || '',
        i18n,
      };

      props.onSelect = (userId) => {
        props.selected = _.findWhere(data.contacts, { 'Value': userId });
        renderPrimaryContactReactComponent(props);
      };

      props.onSubmit = () => {
        const accountIds = _.pluck(gridView.selectedItems(), 'Id');

        postPrimaryContactUpdate(cid, uid, accountIds, props.selected.Value)
          .then((result) => afterUpdate({result, callBack}));
      };

      props.onCancel = () => hide();

      renderPrimaryContactReactComponent(props);
      hideToolbar();
      editorContainer.slideDown();
      isEditing = true;
    };

    function show({cid, uid, callBack}) {
      if (gridView.selectedItems().length) {
        if (toolbar === undefined) {
          throw new Error('Call registerToolbar of this plug in before show the editor.');
        }

        const accountIds = _.pluck(gridView.selectedItems(), 'Id');


        getPrimaryContacts(cid, uid, accountIds)
          .then(
            (data) => {
              if (data.Alert && data.AlertContent) {
                window.App.views.alertCenter.showWarning(data.AlertContent);
              } else {
                renderEditComponent({cid, uid, callBack, data});
              }
            }
          );
      } else {
        hide();
      }
    }

    function registerToolbar(targetToolbar) {
      toolbar = targetToolbar;
    }

    function isInEditing() {
      return isEditing;
    }

    return { registerToolbar, isInEditing, show };
  }
);
